import { Link } from "react-router-dom";

export default function AuthLayout({ eyebrow, title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-obsidian">
      <header className="glass-panel border-x-0 border-t-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-16 sm:h-20">
          <Link to="/" data-testid="auth-brand-link" className="font-serif text-lg sm:text-xl tracking-[0.25em] uppercase text-amber-100/95">
            Monroe <span className="gold-text italic">Society</span>
          </Link>
          <Link to="/signin" data-testid="auth-signin-link" className="text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-gold transition-colors">
            Sign In
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-14 lg:py-20">
        <p className="text-xs uppercase tracking-[0.35em] text-gold/80 mb-4">{eyebrow}</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-amber-100/95 leading-tight mb-4">{title}</h1>
        {subtitle && <p className="text-base text-neutral-400 font-light leading-relaxed mb-10">{subtitle}</p>}
        {children}
      </main>
    </div>
  );
}
